import { graphql, useStaticQuery } from 'gatsby'
import React, { FC } from 'react'
import styled from 'styled-components'
import { prop } from 'styled-tools'

const Background = styled.div`
  position: fixed;
  background-color: #fff;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  width: 100%;
  background-image: url(${prop('filename')});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`

const MessageBackground: FC = ({}) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile {
        edges {
          node {
            relativePath
            publicURL
            name
          }
        }
      }
    }
  `)

  const filename = () =>
    data.images.edges.find((n) => {
      return n.node.name.includes('messages-bg')
    }).node.publicURL

  return (
    <>
      <Background filename={filename()} filenameDesktop={filename()} />
    </>
  )
}

export default MessageBackground
